import { render, staticRenderFns } from "./_UserWrapper.vue?vue&type=template&id=1e18bc89&scoped=true&"
import script from "./_UserWrapper.vue?vue&type=script&lang=js&"
export * from "./_UserWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e18bc89",
  null
  
)

export default component.exports